"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useComponentSize_1 = __importDefault(require("../../hooks/useComponentSize"));
const LoadingPlaceholder = ({ children, control, style, }) => {
    const [size, onLayout] = (0, useComponentSize_1.default)();
    const { Render, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const isLoading = control.isDynamicLoadingEnabled || control.isLoadingState;
    if (isLoading) {
        const { width, height, borderTopRightRadius, borderTopLeftRadius, borderBottomRightRadius, borderBottomLeftRadius, } = style;
        const isSizePercentage = typeof width === 'string' || typeof height === 'string';
        let boneLayoutStyles = {
            width,
            height,
            borderTopRightRadius,
            borderTopLeftRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius,
        };
        if (isSizePercentage && size) {
            boneLayoutStyles = Object.assign(Object.assign({}, boneLayoutStyles), size);
        }
        if (isSizePercentage && !size) {
            boneLayoutStyles = Object.assign(Object.assign({}, boneLayoutStyles), { width: 0, height: 0 });
        }
        const boneLayout = Object.assign({ key: 'someId' }, boneLayoutStyles);
        const vieStyle = Object.assign(Object.assign({}, style), { padding: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 0, paddingTop: 0, borderBottomWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderTopWidth: 0, borderStyle: undefined });
        return (react_1.default.createElement(Render.View, { onLayout: onLayout, style: vieStyle },
            react_1.default.createElement(Render.SkeletonContent, { isLoading: isLoading, layout: boneLayout }, children)));
    }
    return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    react_1.default.createElement(react_1.default.Fragment, null, children));
};
exports.default = LoadingPlaceholder;
